import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const InputStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  /* Child element styles
  ------------------------------- */
  .input {
    border-radius: 10px;
    border: ${VARIABLES.BORDER_WIDTHS.MN} solid ${VARIABLES.COLORS.GRAY_2};
    background-color: white;
    flex: 1 1 auto;
    height: 40px;

    &:focus {
      outline: none;
      border-color: #6c63ff;
      box-shadow: 0 0 0 3px rgba(108, 99, 255, 0.25);
    }
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};
    color: ${VARIABLES.COLORS.GRAY_3};
    padding: 0 14px;
    width: 100%;

    ::-webkit-input-placeholder {
      color: ${VARIABLES.COLORS.GRAY_5};
    }

    :-ms-input-placeholder {
      color: ${VARIABLES.COLORS.GRAY_5};
    }

    ::placeholder {
      color: ${VARIABLES.COLORS.GRAY_5};
    }

    :-webkit-autofill,
    :-webkit-autofill:focus {
      transition: background-color 600000s 0s, color 600000s 0s;
    }

    :-webkit-autofill {
      -webkit-text-fill-color: ${VARIABLES.COLORS.GRAY_3} !important;
    }
  }

  .label {
    color: #1f2937;
    font-size: 14px;
    font-weight: 600;
    //margin-bottom: 10px;
  }

  .text-right {
    .input {
      justify-content: end;
      text-align: right;
    }
  }

  /* Modifiers
  ------------------------------- */
  &.paginate-moveto {
    width: 100px;
    height: 34px;

    .label {
      flex: 0 0 50px;
      font-size: 14px;
    }

    .input {
      min-width: 50px;
      height: 34px;
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XS};
      text-align: center;
      padding: 0 7px;
      width: auto;
      flex: 1 1 50px;
    }
  }

  &.theme-blue {
    .input {
      color: ${VARIABLES.COLORS.BLUE_1};
    }

    .label {
      color: #1f2937;
    }
  }
  &.search_input_check {
    pointer-events: none;
    width: 30%;
    margin-right: 10px;
  }
  &.is-horizontal {
    flex-direction: row;
    align-items: center;

    .label {
      margin-bottom: 0;
    }
  }

  /* State
  ------------------------------- */
  &.is-disabled {
    .input {
      background-color: ${VARIABLES.COLORS.GRAY_8} !important;
      color: ${VARIABLES.COLORS.GRAY_10} !important;
    }
  }

  &.is-read-only {
    .input {
      background-color: ${VARIABLES.COLORS.GRAY_8} !important;
      color: ${VARIABLES.COLORS.GRAY_10} !important;
      cursor: default;
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    .input {
      height: 40px;
      font-size: 16px;
    }

    .label {
      font-size: 16px;
    }

    &.paginate-moveto {
      width: 95px;
      height: 34px;

      .label {
        flex: 0 0 45px;
        font-size: 13px;
      }

      .input {
        min-width: 45px;
        height: 34px;
        font-size: 13px;
        padding: 0 7px;
        flex: 1 1 45px;
      }
    }
  }

  @media all and (max-width: 1440.98px) {
    .input {
      height: 38px;
      font-size: 15px;
    }

    .label {
      font-size: 15px;
    }

    &.paginate-moveto {
      width: 90px;
      height: 32px;

      .label {
        flex: 0 0 40px;
      }

      .input {
        min-width: 40px;
        height: 32px;
        padding: 0 6px;
        flex: 1 1 40px;
      }
    }
  }

  @media all and (max-width: 1366.98px) {
    .input {
      height: 36px;
      font-size: 14px;
      padding: 0 12px;
    }

    .label {
      font-size: 14px;
    }

    &.paginate-moveto {
      width: 82px;
      height: 30px;

      .label {
        flex: 0 0 38px;
        font-size: 12px;
      }

      .input {
        min-width: 42px;
        height: 30px;
        font-size: 12px;
        flex: 1 1 42px;
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    .input {
      height: 34px;
      font-size: 13px;
    }

    .label {
      font-size: 13px;
    }

    &.paginate-moveto {
      width: 80px;
      height: 29px;

      .label {
        flex: 0 0 36px;
      }

      .input {
        min-width: 39px;
        height: 29px;
        padding: 0 5px;
        flex: 1 1 39px;
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    .input {
      height: 32px;
      font-size: 12px;
      padding: 0 10px;
    }

    .label {
      font-size: 12px;
    }

    &.paginate-moveto {
      width: 75px;
      height: 27px;

      .label {
        flex: 0 0 32px;
        font-size: 11px;
      }

      .input {
        min-width: 35px;
        height: 27px;
        font-size: 11px;
        padding: 0 5px;
        flex: 1 1 35px;
      }
    }
  }
`
